import Devices from 'types/Devices';
import { useTranslation } from 'react-i18next';
import 'assets/css/components/HiddenResult.scss';

type HiddenResultProps = {
  type: Devices,
  url: string,
  title: string,
  description: string
};

const HiddenResult = ({ type, url, title, description }: HiddenResultProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={ `hidden_result result_${type}` } aria-hidden='true'>
      <span id={ `hidden_result_${t('form_url_title')}` }>{ url }</span>
      <span id={ `hidden_result_${t('form_title_title')}` }>{ title }</span>
      <span id={ `hidden_result_${t('form_description_title')}` }>{ description }</span>
    </div>
  );
}

export default HiddenResult;
